<template>
    <section id="swipe" :style="{height: offsetWidth/2+'px'}">
        <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item, index) in swipes" :key="index">
                <img v-bind:src="item" />
            </mt-swipe-item>
        </mt-swipe>
    </section>
</template>

<script>
    export default {
        props: ['swipes'],
        computed: {
            offsetWidth () {
                return document.body.offsetWidth
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #swipe{
        overflow: hidden;
    }
    .mint-swipe-indicators{
        left:auto;
        right:px2rem(12);
        bottom:px2rem(12);
        .mint-swipe-indicator{
            height:px2rem(6);
            width:px2rem(6);
            opacity: 1;
            background: #fff;
        }
        .is-active{
            background: #FF4A2A;
        }
    }
    .mint-swipe-item{
        display: flex !important;
        align-items: center !important;
    }
    .mint-swipe img {
        width: 100%;
    }
</style>